import { Injectable } from '@angular/core';
import { doc, docData, Firestore, getDoc } from '@angular/fire/firestore';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Customer } from '@no-kno/core/models/customer.model';

import { environment } from '@no-kno/env/environment';

@Injectable()
export class TenantService {

  customer!: string;
  private aliases!: Map<string, string>;

  constructor(
    private firestore: Firestore
  ) {}

  public async loadConfig(): Promise<void> {

    console.debug('TenantService.loadConfig', 'Loading tenant configuration...');

    const defaultCustomerId = environment.customer.default;
    const result = environment.customer.regex.exec(location.host);

    let alias: string | undefined;
    this.aliases = await this.getCustomerAliases();
    console.debug('TenantService.loadConfig', `Found ${this.aliases.size} customer aliases`);

    alias = this.getAliasFromPath(location.pathname);

    if (result?.[1] && !alias) {
      alias = result[1];
    }

    if (alias) {
      const customerId = this.aliases.get(alias)
      if (customerId) {
        console.debug('TenantService.loadConfig', `Setting customer to ${customerId}`);
        this.customer = customerId;
        return;
      }
    }
    this.customer = defaultCustomerId;
    console.debug('TenantService.loadConfig', `No alias found, setting customer to default: ${this.customer}`);
  }

  public getAliasFromPath(path:string) : string | undefined{
    if (this.aliases.size === 0) {
      console.warn('TenantService.getAliasFromPath', 'No aliases loaded yet, returning undefined');
      return undefined;
    }

    // Match only if path starts with /c/{alias}/ or /c/{alias}
    const pathMatch = /^\/c\/([^\/]+)(\/|$)/.exec(path);
    let alias: string | undefined;
    if (pathMatch && pathMatch[1]) {
      alias = pathMatch[1];
      if (!this.aliases.has(alias)) {
        console.warn('TenantService.loadConfig', `Alias ${alias} not found in customer aliases`);
        alias = undefined;
      }
    }
    return alias;
  }

  private async getCustomerAliases() : Promise<Map<string, string>> {
    try {
      const ref = doc(this.firestore, 'config/aliases');
      const snap = await getDoc(ref);
      const data = snap.data();
      return data ? new Map(Object.entries(data)) : new Map();
    }
    catch (error) {
      console.error('TenantService.getCustomerAliases', 'Error fetching customer aliases', error);
      return new Map();
    }
  }

  getCustomerData(id: string): Observable<Customer | null> {
    const ref = doc(this.firestore, 'customers', id);
    return docData(ref).pipe(map(data => (data ? ({ id, ...data }) as Customer : null)));
  }

}
